<template>
  <div
    class="copywrap"
    @mouseover="statusList ? void 0 : showHint()"
    @mouseleave="hideHint"
  >
    <div
      v-if="statusList"
      class="list-overlay"
      @click="closeList"
    />
    <div
      v-if="statusList"
      class="list-settings"
    >
      <div class="list-settings-action">
        <div class="list-settings-title">
          {{ settingsList.length ? 'Recently saved' : 'None saved yet' }}
        </div>
        <a
          class="list-settings-close fas fa-times"
          @click.prevent="closeList"
        />
      </div>
      <ActionSettingList
        :settings-list="settingsList"
        @changeStorageSettings="changeStorageSettings"
      />
    </div>
    <el-button
      class="copyButton"
      icon="fas fa-cog"
      @click="openList"
    />
    <div class="hintWrapper">
      <div
        v-if="status"
        class="hintButton share"
      >
        {{ hint }}
      </div>
    </div>
  </div>
</template>
<script>
import ActionSettingList from '@/widgets/common/ActionSettingsList'
import {hintMixin} from "@/mixins/hint.mixin";
export default {
  name: 'ActionLoadSettings',
  components: {
    ActionSettingList
  },
  mixins: [hintMixin],
  props: {
    hint: {
      type: String,
      required: true
    },
    storageSettings: {
      type: Boolean
    }
  },
  data() {
    return {
      statusList: false
    }
  },
  emits: ['changeStorageSettings'],
  computed: {
    settingsList() {
      if (this.storageSettings) {
        const list = this.$localStorage.get('settingsList') || '[]'
        return JSON.parse(list).reverse()
      } else {
        const list = this.$localStorage.get('settingsList') || '[]'
        return JSON.parse(list).reverse()
      }
    }
  },
  methods: {
    changeStorageSettings(value) {
      this.$emit('changeStorageSettings', value)
    },
    openList() {
      this.statusList = true
      this.status = false
    },
    closeList() {
      this.statusList = false
    }
  }
}
</script>
<style lang="scss">
.copywrap {
  position: relative;
}

.list-settings {
  position: absolute;
  display: block;
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  z-index: 99999;
  min-width: 280px;
  min-height: 120px;
  left: -30px;
  transform: translateY(calc(-50% - 15px));
  box-shadow: 0 8px 40px rgba(50, 123, 186, 16), 0 4px 4px rgba(50, 123, 186, 0);

  &-action {
    display: flex;
    justify-content: space-between;
    color: #6c7683;
    align-items: center;
    margin-bottom: 10px;
  }

  &-close {
    font-size: 14px;
    cursor: pointer;
    font-width: normal;
  }

  ul {
    display: block;
    list-style: none;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 110px;
    overflow: auto;

    li {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .trash {
      color: #327bba;
      font-size: 12px;
      cursor: pointer;
      margin-right: 5px;
    }

    a {
      text-decoration: none;
      color: #327bba;
      padding-left: 5px;
      position: relative;
      line-height: 1.25;
    }
  }
}
@media only screen and (min-width: 992px) {
  .list-settings {
    min-width: 320px;
  }
}
.setting-actions {
  position: relative;
  i, a {
    color: #327bba;
    font-size: 14px;
    margin-left: 5px;
    cursor: pointer;
  }
  .hint-copy {
    position: absolute;
    left: -40px;
    font-size: 14px;
    top: 50%;
    transform: translateY(-50%);
    background-color: #fff;
    display: none;
    &.active {
      display: flex;
    }
  }
}

.list-overlay {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}
</style>
